import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './Tabs.Style';

const Tabs = ({ tabContentItem, forForms, onTabChange}) => {
  const [activeSection, setActiveSection] = useState(tabContentItem[0].id);

  const handleButtonClick = (id) => {
    if (activeSection !== id) {
      setActiveSection(id);
      if (onTabChange) {
        onTabChange(id);
      }
    }
  };

  return (
    <S.Container forForms={forForms}>
      <S.TabButtonGroup
        forForms={forForms}
        activeIndex={tabContentItem.findIndex(item => item.id === activeSection)}
        tabCount={tabContentItem.length}
      >
        {tabContentItem.map(({ id, mainTitleTab }) => (
          <S.TabButton
            key={id}
            isActive={activeSection === id}
            onClick={() => handleButtonClick(id)}
            type='button'
          >
            <S.TabTitle>
              {mainTitleTab}
            </S.TabTitle>
          </S.TabButton>
        ))}
      </S.TabButtonGroup>
      {tabContentItem.map(({ id, content }) => (
        activeSection === id && (
          <S.TabContent key={id}>
            {content}
          </S.TabContent>
        )
      ))}
    </S.Container>
  );
}

Tabs.propTypes = {
  tabContentItem: PropTypes.arrayOf(
    PropTypes.shape({
      mainTitleTab: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired
    })
  ).isRequired,
  forForms: PropTypes.bool,
  onTabChange: PropTypes.func
};

Tabs.defaultProps = {
  forForms: false,
  onTabChange: ""
};

export default Tabs;
